<div class="box-menu-settings settings-image active mb-5">
	<span data-testid="SUBSYS7_IMAGEELABORATION_TOGGLE_BTN" class="title-accordion bg-transparent m-0"
		[class]="{'active': !isCollapsed }" (click)="isCollapsed = !isCollapsed" (keypress)="isCollapsed = !isCollapsed">
		{{ labels().IMAGE_ELABORATION_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>

	<div [ngbCollapse]="isCollapsed">

		<div class="wrapper-image-setup">
			<div data-testid="SUBSYS7_IMAGEELABORATION_LINE_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_LINE" [class]="{'clickable': true }" (click)="addLine()"
				(keypress)="addLine()">
				<i class="material-icons">straighten</i>
			</div>
			<div data-testid="SUBSYS7_IMAGEELABORATION_GONIOMETER_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_GONIOMETER" [class]="{'clickable': true }"
				(click)="addGoniometer()" (keypress)="addGoniometer()">
				<div class="fake-material-icon protractor"></div>
			</div>
			<div data-testid="SUBSYS7_IMAGEELABORATION_DELETE_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_DELETE"
				[class]="{'clickable': isDeleteEnabled, 'disabled': !isDeleteEnabled }" style="margin-left: 5rem;"
				(click)="deleteTool()" (keypress)="deleteTool()">
				<div class="material-icons" style="cursor: inherit;">delete_outline</div>
			</div>
		</div>
		<div class="row-box">
			<i class="material-icons">brightness_5</i>
			<span>{{ labels().IMAGE_ELABORATION_COMPONENT_BRIGHTNESS }}</span>
		</div>
		<div class="row-box">
			<input id="brightnessSlider" type="text" />
		</div>
		<div class="row-box">
			<i class="material-icons">tonality</i>
			<span>{{ labels().IMAGE_ELABORATION_COMPONENT_CONTRAST }}</span>
		</div>
		<div class="row-box">
			<input id="contrastSlider" type="text" />
		</div>

	</div>
</div>